import React from 'react';

import SelectField from '../../components/form/SelectField';
import usStates from '../../lib/usStates';

export interface StateSelectFieldProps {
  name: string;
}

// These forms have always offered PR but not VI. VI lives in the canonical
// list for the rescue portal's hardware order forms, so filter it back out
// here rather than changing where consumer orders can ship.
const stateOptions = usStates
  .filter(({ abbreviation }) => abbreviation !== 'VI')
  .map(({ name, abbreviation }) => ({
    label: name,
    value: abbreviation,
  }));

export default function StateSelectField({ name }: StateSelectFieldProps) {
  return (
    <SelectField
      menuPlacement="top"
      autoComplete="address-level1"
      name={name}
      placeholder="State"
      options={stateOptions}
    />
  );
}
